import apiHelper from '../helpers/apiHelper'
import investor from '@/api/investor'

export default {
  create(data)
  {
    data = investor.processing(data)
    return apiHelper.request('investor', data, 'POST')
  },
  update(data)
  {
    data = investor.processing(data)
    return apiHelper.request('investor', data, 'PUT')
  }
}
